import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { useTheme } from '@mui/material'
import React, { memo } from 'react'

const FaIcon = ({ ...restProps }) => {
  // const theme = useTheme() // Access MUI theme

  return (
    <FontAwesomeIcon
      {...restProps}
      // style={{
      //   '--fa-primary-color': theme.palette.primary.main, // Primary color
      //   '--fa-secondary-color': theme.palette.grey[400] // Secondary color (gray)
      // }}
    />
  )
}

export default memo(FaIcon)
